require('@babel/polyfill');
window.jQuery = window.$ = require('jquery');
var processInclude = require('base/util');
var tagManager = require('int_googletags/tagManager');

$(document).ready(function () {
    if ($('body').hasClass('combat')) {
        processInclude(require('combat/components/menu'));
    } else {
        processInclude(require('./components/menu'));
    }
    processInclude(require('base/components/cookie'));
    processInclude(require('base/components/consentTracking'));
    processInclude(require('./components/footer'));
    processInclude(require('lyonscg/components/backtotop'));
    processInclude(require('./components/miniCart'));
    processInclude(require('./content/lazyload'));
    processInclude(require('base/components/collapsibleItem'));
    processInclude(require('./components/search'));
    processInclude(require('./components/carousels'));
    processInclude(require('lyonscg/components/clientSideValidation'));
    processInclude(require('base/components/countrySelector'));
    processInclude(require('lyonscg/components/carousels'));
    processInclude(require('lyonscg/components/tooltips'));
    processInclude(require('./cart/cart'));
    processInclude(require('base/components/toolTip'));
    processInclude(require('./components/footerToggle'));
    processInclude(require('pagedesigner/experience'));
    processInclude(require('wishlists/product/wishlistHeart'));
    tagManager.init(window.pageContext.ns);
});

require('lyonscg/thirdParty/bootstrap');
require('base/components/spinner');
require('svg4everybody');
require('slick-carousel');
require('picturefill');
require('readmore-js');
require('sticky-sidebar-v2/dist/jquery.sticky-sidebar');
require('@cloudimage/360-view');
require('@cloudimage/360-view/css');
